import { IonContent, IonPage } from '@ionic/react';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { NestedPageHeader } from '../../components/header/page.header';
import { TenantAdministration } from '../../components/tenant/tenant';
import { useBeaconRouter } from '../../route/route.hooks';
import { DeleteTenantButton } from './delete-tenant-button';

const TenantAdminPage = (): ReactElement => {
  const { i18n } = useTranslation();
  const { builder } = useBeaconRouter();

  return (
    <IonPage>
      <NestedPageHeader
        title={i18n.t('common:workspace')}
        defaultBackRoute={builder.getAdminRoute()}
        rightButtons={<DeleteTenantButton />}
      />
      <IonContent>
        <TenantAdministration />
      </IonContent>
    </IonPage>
  );
};

export { TenantAdminPage };
